export default "__VITE_ASSET__26becf59__"